var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.39641C13.5 10.9863 10.5899 13.8964 7 13.8964C2.19565 13.8964 0.5 10.9863 0.5 7.39641C0.5 3.80656 3.41015 0.896408 7 0.896408C10.5899 0.896408 13.5 2.59206 13.5 7.39641Z",
    fill: "#FF00FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94543 10.7439C5.8722 10.7426 5.80204 10.7136 5.74858 10.6624L2.58487 7.49917C2.55841 7.47274 2.53729 7.44123 2.52273 7.40645C2.50817 7.37167 2.50045 7.3343 2.50002 7.29647C2.49958 7.25864 2.50644 7.2211 2.52019 7.18598C2.53395 7.15086 2.55433 7.11885 2.58019 7.09178C2.60604 7.06472 2.63685 7.04313 2.67086 7.02824C2.70487 7.01335 2.74142 7.00546 2.77841 7.00502C2.81541 7.00457 2.85212 7.01158 2.88647 7.02565C2.92081 7.03971 2.95211 7.06056 2.97858 7.08699L5.94543 10.0537L11.0214 4.97816C11.0479 4.95173 11.0792 4.93088 11.1135 4.91681C11.1479 4.90275 11.1846 4.89574 11.2216 4.89618C11.2586 4.89663 11.2951 4.90452 11.3291 4.91941C11.3632 4.9343 11.394 4.95589 11.4198 4.98295C11.4457 5.01002 11.4661 5.04202 11.4798 5.07714C11.4936 5.11226 11.5004 5.14981 11.5 5.18764C11.4995 5.22547 11.4918 5.26284 11.4773 5.29762C11.4627 5.3324 11.4416 5.36391 11.4151 5.39034L6.14228 10.6624C6.08882 10.7136 6.01866 10.7426 5.94543 10.7439Z",
    fill: "#1A1717",
    stroke: "black",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.c0c66ae38987dffa35877eb6859a6c54.svg";
export { ForwardRef as ReactComponent };